import { Quill } from 'react-quill';

// Quill의 Blot 모듈 가져오기
const Block = Quill.import('blots/block');
const Container = Quill.import('blots/container');

// Table Cell Blot 정의
class TableCellBlot extends Block {
  static blotName = 'table-cell';
  static tagName = 'td';
  static scope = Quill.import('parchment').Scope.BLOCK_BLOT;

  static create(value: any) {
    const node = super.create(value) as HTMLElement;
    node.setAttribute('contenteditable', 'true');
    node.setAttribute('data-row', value?.row || '0');
    node.setAttribute('data-col', value?.col || '0');
    return node;
  }

  static formats(domNode: HTMLElement) {
    return {
      row: domNode.getAttribute('data-row'),
      col: domNode.getAttribute('data-col'),
    };
  }

  format(name: string, value: any) {
    if (name === TableCellBlot.blotName && value) {
      this.domNode.setAttribute('data-row', value.row || '0');
      this.domNode.setAttribute('data-col', value.col || '0');
    } else {
      super.format(name, value);
    }
  }

  optimize(context: any) {
    super.optimize(context);
    const parent = this.parent;
    if (parent != null && parent.statics.blotName !== TableRowBlot.blotName) {
      // 부모가 tr이 아니면 감싸기
      this.wrap(TableRowBlot.blotName, true);
    }
  }
}

// Table Row Blot 정의
class TableRowBlot extends Container {
  static blotName = 'table-row';
  static tagName = 'tr';
  static scope = Quill.import('parchment').Scope.BLOCK_BLOT;

  static create(value: any) {
    const node = super.create(value) as HTMLElement;
    return node;
  }

  optimize(context: any) {
    super.optimize(context);
    const parent = this.parent;
    if (parent != null && parent.statics.blotName !== TableBlot.blotName) {
      // 부모가 table이 아니면 감싸기
      this.wrap(TableBlot.blotName, true);
    }
  }
}

// Table Blot 정의
class TableBlot extends Container {
  static blotName = 'table';
  static tagName = 'table';
  static scope = Quill.import('parchment').Scope.BLOCK_BLOT;

  static create(value: any) {
    const node = super.create(value) as HTMLElement;
    return node;
  }

  insertBefore(blot: any, ref: any) {
    if (blot.statics.blotName === TableRowBlot.blotName) {
      super.insertBefore(blot, ref);
    } else {
      const row = this.descendants(TableRowBlot)[0];
      if (row) {
        row.insertBefore(blot, ref);
      }
    }
  }

  balanceCells() {
    const rows = this.descendants(TableRowBlot);
    const maxCols = Math.max(...rows.map((row: any) => row.children.length));
    
    rows.forEach((row: any) => {
      const cellCount = row.children.length;
      if (cellCount < maxCols) {
        for (let i = cellCount; i < maxCols; i++) {
          const cell = Quill.import('parchment').create(TableCellBlot.blotName);
          row.appendChild(cell);
        }
      }
    });
  }

  optimize(context: any) {
    super.optimize(context);
    this.balanceCells();
  }
}

// 자식 요소 허용 설정
TableBlot.allowedChildren = [TableRowBlot];
TableRowBlot.allowedChildren = [TableCellBlot];
TableCellBlot.allowedChildren = [Block, Quill.import('blots/break')];

// Quill에 등록
Quill.register(TableBlot);
Quill.register(TableRowBlot);
Quill.register(TableCellBlot);
